module.exports = __webpack_public_path__ + "static/media/drag-down.880836f4.svg";